"use client";

import React from "react";
import { createIcon } from "@chakra-ui/react";

const EducationalResourcesIcon = createIcon({
  displayName: "EducationalResourcesIcon",
  viewBox: "0 0 45 37",
  path: (
    <>
      <path
        d="M22.5,37l-14.32-7.81v-12.33L0,12.33,22.5,0l22.5,12.33v16.44h-4.09v-14.18l-4.09,2.26v12.33l-14.32,7.81ZM22.5,19.94l14.01-7.61-14.01-7.61-14.01,7.61,14.01,7.61ZM22.5,32.32l10.23-5.55v-7.76l-10.23,5.65-10.23-5.65v7.76l10.23,5.55Z"
        fill="currentColor"
      />
    </>
  ),
  defaultProps: {
    boxSize: "1em",
  },
});

export default EducationalResourcesIcon;
